import { useQueryStates } from 'nuqs';
import { useEffect } from 'react';
import { useSession } from '@/components/session/useSession';
import { SEARCH_PARAMS } from '@/routes/search-params';
import { StatusQuoAnalysisTabEnum } from '@/routes/search_params/searchParamsEnums';
import { getStoredActiveTab } from '@/sections/StatusQuoAnalysis/contexts/activeTabStorage';

// An explicit `?tab=` in the URL (e.g. a shared link) always wins over the stored value.
export function useRestoreLastActiveTab(storageKey: string | undefined) {
  const { featureFlags } = useSession();
  const [, setQueryParams] = useQueryStates(SEARCH_PARAMS.statusQuoAnalysis.building);

  useEffect(() => {
    if (!storageKey || new URLSearchParams(window.location.search).has('tab')) return;

    const storedTab = getStoredActiveTab(storageKey);
    if (
      storedTab &&
      (storedTab !== StatusQuoAnalysisTabEnum.CONSUMPTION || featureFlags.CONSUMPTION_STATUS_QUO_TAB_ENABLED)
    ) {
      void setQueryParams({ tab: storedTab }, { history: 'replace' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
